import {flashError} from './errors';

function asyncRequest(
	types: AsyncActionTypes,
	scope: ActionScope,
	requestId: number,
): AsyncRequestAction {
	return {
		type: 'ASYNC_REQUEST',
		asyncRequestData: {requestId},
		scope,
	};
}

function asyncSuccess(
	types: AsyncActionTypes,
	scope: ActionScope,
	requestId: number,
	data: any,
): AsyncSuccessAction {
	return {
		type: 'ASYNC_SUCCESS',
		successReference: types.SUCCESS,
		asyncSuccessData: {requestId, data},
		scope,
	};
}

function asyncFailure(
	types: AsyncActionTypes,
	scope: ActionScope,
	requestId: number,
	error: any,
): AsyncFailureAction {
	return {
		type: 'ASYNC_FAILURE',
		failureReference: types.FAILURE,
		asyncFailureData: {requestId, error},
		scope,
	};
}

let requestIdCounter = 0;

export function getScopedAsyncAction<R>(
	types: AsyncActionTypes,
	scope: ActionScope,
	fn: (getState: () => StudioState) => Promise<R>,
	preventErrorFlash?: 'DONT_FLASH_ERROR',
): AsyncAction<R> {
	return (dispatch, getState) => {
		const requestId = ++requestIdCounter;
		if (types.REQUEST) {
			dispatch(asyncRequest(types, scope, requestId));
		}
		return fn(getState)
			.then(data => {
				dispatch(asyncSuccess(types, scope, requestId, data));
				return data;
			})
			.catch(error => {
				dispatch(asyncFailure(types, scope, requestId, error));
				if (!preventErrorFlash) {
					dispatch(flashError(error));
				}
				throw error;
			});
	};
}

export function provideAuthorizationToken<T>(request: Omit<T, 'authorizationToken'>, {global}: StudioState) {
	if (global.user.authorization) {
		const {authorizationToken} = global.user.authorization;
		return Object.assign({}, request, {authorizationToken});
	} else {
		return Object.assign({}, request, {authorizationToken: ''});
	}
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./ts/store/actions/util/async.ts